import { api } from "app/data/api"

export const getUserPublishes = async () => {
    return await api.get('/publish/list')
}

export const deletePublish = async (id: number) => {
    return await api.delete('/publish/delete', {
        params: {
            id
        }
    })
}

export const createPublish = async (data:any) => {
    return await api.post('/publish/create', {
        authors:    data.authors, 
        title:      data.title, 
        journal:    data.journal, 
        year:       data.year, 
        doi:        data.doi, 
        active:     data.active, 
    })
}

export const updatePublish = async (data:any) => {
    return await api.patch('/publish/update', {
        id:         data.id,
        authors:    data.authors, 
        title:      data.title, 
        journal:    data.journal, 
        year:       data.year, 
        doi:        data.doi, 
        active:     data.active, 
    })
}